import {
  type GridColDef,
  type GridFilterModel,
  type GridSlotsComponent,
} from "@mui/x-data-grid-pro";
import { type FC, useState } from "react";
import type { UsedMomentInfo } from "../../../../modules/moment/server/supabase-moment-service";
import type { UsedProgramInfo } from "../../../../modules/programs/server/supabase-program-service";
import type { UsedSegmentInfo } from "../../../../modules/segment/server/supabase-segment-service";
import { AnalyticsSendsTable } from "../../analytics/send-table/send-table";
import { useSentMomentDataDataSource } from "../hooks/use-sent-moment-data";
import { useSentMomentTableColumns } from "../hooks/use-sent-moment-table-columns";
import { SentMomentsTableToolbar } from "./sent-moments-table-toolbar";

export const AnalyticsSentMomentsTable: FC<{
  segments: Pick<UsedSegmentInfo, "id" | "name">[];
  programs: Pick<UsedProgramInfo, "id" | "name">[];
  moments: Pick<UsedMomentInfo, "id" | "name" | "status">[];
}> = ({ segments, programs, moments }) => {
  const statsDataSource = useSentMomentDataDataSource();
  const [filterModel, setFilterModel] = useState<GridFilterModel>({
    items: [
      {
        id: "moment_status",
        field: "moment_status",
        operator: "not_equals",
        value: "archived",
      },
    ],
  });

  const columns = useSentMomentTableColumns({ segments, programs, moments });

  return (
    <AnalyticsSendsTable
      dataSource={statsDataSource ?? undefined}
      show_polls_and_surveys
      disableRowSelectionOnClick
      columns={columns}
      slots={{ toolbar: SentMomentsTableToolbar as GridSlotsComponent["toolbar"] }}
      showToolbar
      slotProps={{
        columnsManagement: {
          getTogglableColumns: (cols: GridColDef[]) =>
            cols
              .filter((column) => column.field !== "__detail_panel_toggle__")
              .map((column) => column.field),
        },
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any
        toolbar: { setFilterModel } as any,
      }}
      filterModel={filterModel}
      onFilterModelChange={(newFilterModel) => setFilterModel(newFilterModel)}
      initialState={{
        pagination: {
          paginationModel: { pageSize: 50, page: 0 },
          rowCount: 0,
        },
        sorting: { sortModel: [{ field: "min_timestamp", sort: "desc" }] },
        columns: {
          columnVisibilityModel: {
            segment_name: false,
            program_name: false,
            publisher_name: false,
            moment_status: false,
          },
        },
      }}
    />
  );
};
